import React from 'react';
import { motion } from 'framer-motion';
import { Headphones, Volume2, Film, Monitor } from 'lucide-react';

const services = [
  { title: 'Traducción Simultánea', description: 'Equipos y técnicos para traducción en vivo.', icon: <Headphones size={40} /> },
  { title: 'Sonido Profesional', description: 'Sonido de alta fidelidad para todo evento.', icon: <Volume2 size={40} /> },
  { title: 'Proyección HD', description: 'Proyección en alta definición garantizada.', icon: <Film size={40} /> },
  { title: 'Pantallas LED', description: 'Pantallas gigantes para máxima visibilidad.', icon: <Monitor size={40} /> },
];

const EventServices = () => {
  return (
    <section className="py-20 px-6 bg-slate-50">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-16"
      >
        <h2 className="text-4xl font-extrabold text-slate-900 mb-4">Soluciones Técnicas</h2>
        <div className="h-1 w-20 bg-blue-500 mx-auto rounded-full"></div>
      </motion.div>
<section id="servicios" className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Bloque tipo "Líder en tecnología" */}
        <div className="bg-white p-10 rounded-2xl shadow-xl flex flex-col md:flex-row items-center gap-10 border border-slate-100">
          <div className="flex-1">
            <h2 className="text-4xl font-extrabold text-slate-900 mb-6">
              Líderes en <span className="text-blue-600">Soluciones Audiovisuales</span>
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed">
              Contamos con una profunda experiencia en el mundo de los eventos y servicios presenciales. 
              Buscamos siempre soluciones a los desafíos que enfrentan nuestros clientes con originalidad y tecnología de vanguardia.
            </p>
          </div>
          {/* Aquí podrías poner una imagen destacada tuya */}
          <div className="flex-1 w-full h-64 bg-slate-200 rounded-xl overflow-hidden">
             <img src="https://firebasestorage.googleapis.com/v0/b/peyen-de088.firebasestorage.app/o/service.jpg?alt=media&token=1caa11cf-9637-4d5c-9fb9-73c146603352" alt="Equipo MAAC" className="w-full h-full object-cover" />
          </div>
        </div>
      </div>
    </section>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
        {services.map((service, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            whileHover={{ y: -10 }}
            className="p-8 bg-white rounded-2xl shadow-lg border border-slate-100 hover:shadow-2xl transition-all duration-300"
          >
            <div className="text-blue-500 mb-6">{service.icon}</div>
            <h3 className="text-xl font-bold text-slate-800 mb-3">{service.title}</h3>
            <p className="text-slate-600">{service.description}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default EventServices;